import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Blog = () => {
  const blogPosts = [
    {
      id: 'will-ai-replace-software-developers',
      icon: '🛡️',
      date: 'Aug 7, 2026',
      readTime: '5 min read',
      title: 'Will AI Replace Software Developers? The Truth About the Future of Coding',
      description: 'AI is changing how software gets built—but replacing repetitive tasks is not the same as replacing engineers. Here is what developers and leaders need to understand.'
    },
    /* Temporarily hidden until the article is ready to publish.
    {
      id: 'automation-vs-ai-2026',
      icon: '🤖',
      date: 'Aug 7, 2026',
      readTime: '10 min read',
      title: 'Automation vs AI in 2026: How to Choose Without the Hype',
      description: 'A practical decision framework for technical leaders navigating the noise between traditional automation and AI—when to use each, and how to avoid expensive mistakes.'
    },
    */
    {
      id: 'business-goals-technical-architecture',
      icon: '🧩',
      date: 'Oct 15, 2025',
      readTime: '8 min read',
      title: 'The Art of Translating Business Goals into Technical Architecture',
      description: 'Bridging the gap between vision and execution through strategic technical architecture, alignment, and empathy-driven design decisions.'
    },
    {
      id: 'software-engineer-to-project-manager',
      icon: '🚀',
      date: 'Oct 12, 2025',
      readTime: '7 min read',
      title: 'From Software Engineer to Project Manager — My Career Transition Story',
      description: 'A personal journey from writing code to leading teams, and discovering that the most complex systems are built in people, communication, and alignment.'
    }
  ];

  return (
    <div className="container">
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Latest Articles
      </motion.h2>
      <div className="blog-grid">
        {blogPosts.map((post, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <Link to={`/blog/${post.id}`} className="blog-card-link">
              <div className="blog-card">
                <div className="blog-image">{post.icon}</div>
                <div className="blog-content">
                  <div className="blog-meta">
                    <span>{post.date}</span>
                    <span>•</span>
                    <span>{post.readTime}</span>
                  </div>
                  <h3>{post.title}</h3>
                  <p>{post.description}</p>
                  <span className="read-more">Read More →</span>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
